import Icon from "@ant-design/icons";

const Svg = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.0006 17.0001H12.0106M12.0006 10.0001V14.0001M6.4127 21.0001H17.5886C19.3702 21.0001 20.2611 21.0001 20.7836 20.6254C21.2395 20.2985 21.5371 19.7951 21.6039 19.238C21.6804 18.5996 21.2511 17.819 20.3925 16.2579L14.8045 6.09805C13.8903 4.4359 13.4332 3.60482 12.8292 3.32987C12.3028 3.09024 11.6984 3.09024 11.172 3.32987C10.568 3.60482 10.1109 4.4359 9.19675 6.09805L3.60881 16.2579C2.7502 17.819 2.32089 18.5996 2.39738 19.238C2.46413 19.7951 2.76177 20.2985 3.2177 20.6254C3.74022 21.0001 4.63104 21.0001 6.4127 21.0001Z"
        stroke="#FF4E00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}
export const MyIcon = (props: any) => <Icon component={Svg} {...props} />;